import httpService from 'services/http/http.service';
import ApiUrl from 'enum/api-url.enum';

function getThirdPartyService(service, params) {
  let url = `${ApiUrl.THIRDPARTYSERVICE}${service}/`;
  if (params) {
    const queryParams = Object.keys(params)
      .map(key => `${key}=${encodeURIComponent(params[key])}`)
      .join('&');
    url += `?${queryParams}`;
  }
  return httpService.get(url);
}

const obj = { getThirdPartyService };

export default obj;
